(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbx-bundle-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tbx-bundle-grid .kit-includes .toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var kitItems = this.parentElement.querySelector('.kit-items');
      if (kitItems.style.display === 'block') {
        kitItems.style.display = 'none';
        this.classList.remove('active');
      } else {
        kitItems.style.display = 'block';
        this.classList.add('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-features-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-features').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1.10,
          spaceBetween: 15,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          breakpoints: {
            600: { slidesPerView: 2.05 },
            900: { slidesPerView: 2.85 },
            1200: { slidesPerView: 3.10, spaceBetween: 20 },
            1400: { slidesPerView: 4 }
          }
        });
      });
    }
  });

    document.addEventListener("DOMContentLoaded", function () {
    const limit = 200; // Character limit
    document.querySelectorAll(".text-wrapper").forEach(wrapper => {
      const textDiv = wrapper.querySelector(".text");
      const button = wrapper.querySelector(".toggle-text");
      const fullText = textDiv.dataset.fulltext;
      
      if (fullText.length <= limit) {
        button.style.display = "none";
        return;
      }

      let isExpanded = false;
      const truncatedText = fullText.slice(0, limit) + '...';

      textDiv.textContent = truncatedText;

      button.addEventListener("click", () => {
        isExpanded = !isExpanded;
        textDiv.textContent = isExpanded ? fullText : truncatedText;
        button.textContent = isExpanded ? "View Less" : "View More";
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-features-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-features').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1.10,
          spaceBetween: 15,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          breakpoints: {
            600: { slidesPerView: 2.05 },
            900: { slidesPerView: 2.85 },
            1200: { slidesPerView: 3.10, spaceBetween: 20 },
            1400: { slidesPerView: 4 }
          }
        });
      });
    }
  });

    document.addEventListener("DOMContentLoaded", function () {
    const limit = 200; // Character limit
    document.querySelectorAll(".text-wrapper").forEach(wrapper => {
      const textDiv = wrapper.querySelector(".text");
      const button = wrapper.querySelector(".toggle-text");
      const fullText = textDiv.dataset.fulltext;
      
      if (fullText.length <= limit) {
        button.style.display = "none";
        return;
      }

      let isExpanded = false;
      const truncatedText = fullText.slice(0, limit) + '...';

      textDiv.textContent = truncatedText;

      button.addEventListener("click", () => {
        isExpanded = !isExpanded;
        textDiv.textContent = isExpanded ? fullText : truncatedText;
        button.textContent = isExpanded ? "View Less" : "View More";
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-features-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-features').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1.10,
          spaceBetween: 15,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          breakpoints: {
            600: { slidesPerView: 2.05 },
            900: { slidesPerView: 2.85 },
            1200: { slidesPerView: 3.10, spaceBetween: 20 },
            1400: { slidesPerView: 4 }
          }
        });
      });
    }
  });

    document.addEventListener("DOMContentLoaded", function () {
    const limit = 200; // Character limit
    document.querySelectorAll(".text-wrapper").forEach(wrapper => {
      const textDiv = wrapper.querySelector(".text");
      const button = wrapper.querySelector(".toggle-text");
      const fullText = textDiv.dataset.fulltext;
      
      if (fullText.length <= limit) {
        button.style.display = "none";
        return;
      }

      let isExpanded = false;
      const truncatedText = fullText.slice(0, limit) + '...';

      textDiv.textContent = truncatedText;

      button.addEventListener("click", () => {
        isExpanded = !isExpanded;
        textDiv.textContent = isExpanded ? fullText : truncatedText;
        button.textContent = isExpanded ? "View Less" : "View More";
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-product-fit-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-fit-guide').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1.05,
          spaceBetween: 15,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          breakpoints: {
            500: {
              slidesPerView: 1.5,
            },
            700: {
              slidesPerView: 2.3,
            },
            1000: {
              slidesPerView: 3.3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
            }
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-slider-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-slider').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          }          
        });
      });
    }
  });

document.addEventListener('click', function (e) {
  const popup = document.querySelector('.tbx-video-popup');
  const iframe = popup?.querySelector('iframe');

  // Open
  if (e.target.closest('.video-toggle')) {
    const btn = e.target.closest('.video-toggle');
    const videoUrl = btn.getAttribute('data-video-url');
    const autoplayUrl = videoUrl.includes('?')
      ? `${videoUrl}&autoplay=1`
      : `${videoUrl}?autoplay=1`;
    iframe.src = autoplayUrl;
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  // Close
  if (e.target.closest('.close-button')) {
    iframe.src = '';
    popup.classList.add('hidden');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-slider-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-slider').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          }          
        });
      });
    }
  });

document.addEventListener('click', function (e) {
  const popup = document.querySelector('.tbx-video-popup');
  const iframe = popup?.querySelector('iframe');

  // Open
  if (e.target.closest('.video-toggle')) {
    const btn = e.target.closest('.video-toggle');
    const videoUrl = btn.getAttribute('data-video-url');
    const autoplayUrl = videoUrl.includes('?')
      ? `${videoUrl}&autoplay=1`
      : `${videoUrl}?autoplay=1`;
    iframe.src = autoplayUrl;
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  // Close
  if (e.target.closest('.close-button')) {
    iframe.src = '';
    popup.classList.add('hidden');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbx-slider-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      document.querySelectorAll('.tbx-slider').forEach(section => {
        const swiperContainer = section.querySelector('.swiper-container');
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');
        const scrollbar = section.querySelector('.swiper-scrollbar');

        new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
          }          
        });
      });
    }
  });

document.addEventListener('click', function (e) {
  const popup = document.querySelector('.tbx-video-popup');
  const iframe = popup?.querySelector('iframe');

  // Open
  if (e.target.closest('.video-toggle')) {
    const btn = e.target.closest('.video-toggle');
    const videoUrl = btn.getAttribute('data-video-url');
    const autoplayUrl = videoUrl.includes('?')
      ? `${videoUrl}&autoplay=1`
      : `${videoUrl}?autoplay=1`;
    iframe.src = autoplayUrl;
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  // Close
  if (e.target.closest('.close-button')) {
    iframe.src = '';
    popup.classList.add('hidden');
    document.body.style.overflow = '';
  }
});

  } catch(e) { console.error(e); }
})();
})();
